;(function($) {

    'use strict';

    var pluginName = 'address-book';

    var defaults = {
        // Specify where to append modal markup
        appendModalTo: 'body',
        // Submit button selector
        buttonSelector: 'button[type="submit"]:first',
        // Child form element
        formSelector: '.address-form:first',
        // Specify text in modal header
        modalHeaderText: 'Please Verify Your %%type%% Address',
        // Specify modal id attribute
        modalId: 'addressValidateModal',
        // Callback for completed address save
        savedCallback: null,
        //Override default saveModal
        saveModal: null,
        // Message for when a validated address is not found
        notFoundAlertMessage: "<strong>We were unable to validate your address.</strong><br>Please double check your address. If you're sure it is correct, click 'Continue'.",
        // Type of alert for not-found message
        notFoundAlertType: 'info'
    };

    /**
     * AddressBook
     * @constructor
     * @param {Object} target
     * @param {Object} options (Optional)
     */
    function AddressBook(element, options) {
        this.$element = $(element);
        this.addressType = this.$element.data('addressType');
        this.opts = $.extend({}, defaults, options);

        this._init();
    }

    /**
     * Init
     * @private
     */
    AddressBook.prototype._init = function() {
        this.$form = this.$element.find(this.opts.formSelector);
        this.$button = this.$form.find(this.opts.buttonSelector);

        if(this.$form.is('form')) {
            this.$form.on('submit', $.proxy(this._formSubmit, this));
        } else {
            this.$form.on('click', this.opts.buttonSelector, $.proxy(this._formSubmit, this));
        }
    };

    AddressBook.prototype._formSubmit = function(event) {
        event.preventDefault();

        var that = this;

        this.$button.disable().addClass('loading');

        this.$form.find('.alert').remove();

        var original = that._address();

        // validate in US only
        if(original.country !== 'US') {
            that._save(original);
            return;
        }

        var validator = new AddressValidator();

        validator.validate(original)
            .fail(function(xhr){
                that.$form.prependAlert(this.failMessage);
            })
            .always(function(){
                that.$button.enable().removeClass('loading');
            })
            .done(function(data){
                if(data.address !== undefined && data.address.ReturnText !== undefined) {
                    that._returnText(data.address.ReturnText);
                    return false;
                }

                if(data.diff !== undefined) {
                    that.validated = $.extend({}, data.address);

                    data.address = that._wrapFields(data.diff, data.address);

                    if(that.$element.hasClass('modal')) {
                        that._initInModal(data.address, original);
                    } else {
                        that._initModal(data.address, original);
                    }

                    return false;
                }

                if(data.not_found !== undefined) {
                    that.validated = $.extend({}, original);

                    if(that.$element.hasClass('modal')) {
                        that._initInModal(null, original);
                    } else {
                        that._initModal(null, original);
                    }

                    return false;
                }

                that._save(original);
            });
    };

    AddressBook.prototype._initModal = function(update, original) {
        var that = this;

        let contentObject = {
            address2: original
        };
        if(update === null) {
            contentObject.alternateContent = Handlebars.templates['alert']({
                type: that.opts.notFoundAlertType,
                msg: that.opts.notFoundAlertMessage
            });
        } else {
            contentObject.address1 = update;
        }

        let markup = Handlebars.templates['modal']({
            disableClose: true,
            modalId: that.opts.modalId,
            header: {
                title: that._modalHeaderText(),
            },
            content: Handlebars.templates['verify_address'](contentObject),
            actions: [{
                label: '<span>Continue</span>',
                class: 'button-smaller button-loader complete'
            }]
        });

        $(this.opts.appendModalTo).append(markup);

        this.$modal = $('#'+this.opts.modalId);

        this.$modal
            // remove modal when hidden
            .on('hidden.bs.modal', function(event) {
                $(event.target).off('click shown hidden').remove();
                // that._cleanup(true);
            })

            // handle resubmit when shown
            .on('shown.bs.modal', function(){
                var that = this;

                that.$modal
                    .on('click', '.complete', $.proxy(that._saveModal, that))
                    .on('click', '.edit-original', function(event) {
                        $(event.delegateTarget).modal('hide');
                    });
            }.bind(this))

            // show modal
            .modal({
                backdrop: 'static',
                keyboard: false
            });
    };

    AddressBook.prototype._initInModal = function(update, original) {
        let contentObject = {
            address2: original,
            append: {
                template: function(){ return 'actions'; },
                data: {
                    class: 'faux-footer',
                    actions: [{
                        label: '<span>Continue</span>',
                        class: 'button-smaller button-loader complete'
                    }]
                }
            }
        };
        if(update === null) {
            contentObject.alternateContent = Handlebars.templates['alert']({
                type: this.opts.notFoundAlertType,
                msg: this.opts.notFoundAlertMessage
            });
        } else {
            contentObject.address1 = update;
        }

        $('#modal-address-verify').html(
            Handlebars.templates['verify_address'](contentObject)
        ).show();
        $('#modal-address').hide();

        this.$element
            .on('click', '.complete', $.proxy(this._saveModal, this))
            .on('click', '.edit-original', function(event) {
                $('#modal-address', event.delegateTarget).show();
                $('#modal-address-verify', event.delegateTarget).hide().off('click').empty();
                $(event.delegateTarget).off('click', '.complete');
                $(event.delegateTarget).off('click', '.edit-original');
            });
    };

    AddressBook.prototype._returnText = function(text) {
        let msg = text.replace('Default address: ', '')
                + " <strong>Please update your address and try again.</strong>";

        this.$form.prependAlert(msg, 'warning');
    };

    AddressBook.prototype._wrapFields = function(diff, address) {
        $.each(diff, function(key, value){
            if(!value) return;
            address[key] = '<strong>'+value+'</strong>';
        });

        return address;
    };

    AddressBook.prototype._modalHeaderText = function() {
        var type = '';
        if(this.addressType === 'ship') {
            type = 'Shipping';
        } else if(this.addressType == 'bill') {
            type = 'Billing';
        }
        return this.opts.modalHeaderText.replace('%%type%%', type);
    };

    AddressBook.prototype._address = function(address) {
        var original = this.$form.find(':input').serializeJSON();

        original = Object.keys(original).reduce((carry, key) => {
          carry[key] = original[key].replace(/<[^>]+>/gi, '');

          return carry;
        }, {});

        if(this.addressType) {
            original = stripFromKeys(original, this.addressType + '_');
        }

        var updated = $.extend(
            {},
            original,
            (address !== undefined) ? address : {}
        );

        if(original.address2 && address !== undefined && !$.isEmptyObject(address) && !address.address2) {
            updated.address2 = '';
        }

        return updated;
    };

    AddressBook.prototype._save = function(address) {
        var that = this;

        if(typeof that.opts.save === 'function') {
            that.opts.save.call(that, address);
            return;
        }

        that.$button.disable().addClass('loading');

        $.post('/service/address/add', address, null, 'json')
            .fail(function(xhr){
                console.log(xhr);

                var v = new AddressValidator;

                v.xhrFail.call(this, xhr);

                // var failMessage = 'There was a problem saving your address. Please try again.';

                // if(xhr.responseJSON !== undefined) {
                //     if(xhr.responseJSON.errors !== undefined) {
                //         failMessage = AddressValidator.formatValidationErrors(xhr.responseJSON.errors);
                //     } else if(xhr.responseJSON.message !== undefined) {
                //         failMessage = xhr.responseJSON.message;
                //     }
                // }

                that.$form.prependAlert(this.failMessage);
            })
            .always(function(){ that.$button.enable().removeClass('loading'); })
            .done(function(response){
                if(typeof that.opts.savedCallback === 'function') {
                    that.opts.savedCallback.call(that, response);
                    return;
                } else {
                    response.address['csrf_token'] = document.getElementsByName('_token')[0].value;

                    $('#existing-addresses > .row:first').append(
                        Handlebars.templates['full_address'](response.address)
                    );
                }

                that._cleanup();
            });
    };

    AddressBook.prototype._saveModal = function(event) {
        var that = this;

        if(typeof that.opts.saveModal === 'function') {
            that.opts.saveModal.call(that, event);
            return;
        }

        var $button = $(event.target);
        $button.disable().addClass('loading');

        // pass updated or original
        var value = $('[name="verify_addr"]:checked', event.delegateTarget).val();
        var address = that._address( ('recommend' === value) ? that.validated : undefined );

        // post data
        $.post('/service/address/add', address, null, 'json')
            .fail(function(xhr){
                console.log(xhr);

                var v = new AddressValidator;

                v.xhrFail.call(this, xhr);

                // var failMessage = 'There was a problem saving your address. Please try again.';

                // if(xhr.responseJSON !== undefined) {
                //     if(xhr.responseJSON.errors !== undefined) {
                //         failMessage = AddressValidator.formatValidationErrors(xhr.responseJSON.errors);
                //     } else if(xhr.responseJSON.message !== undefined) {
                //         failMessage = xhr.responseJSON.message;
                //     }
                // }

                that.$form.prependAlert(this.failMessage);
            })
            .always(function(){ $button.enable().removeClass('loading'); })
            .done(function(response){
                if(typeof that.opts.savedCallback === 'function') {
                    that.opts.savedCallback.call(that, response);
                    return;
                } else {
                    response.address['csrf_token'] = document.getElementsByName('_token')[0].value;

                    $('#existing-addresses > .row:first').append(
                        Handlebars.templates['full_address'](response.address)
                    );

                    $('html, body').stop().animate({
                        scrollTop: $('#existing-addresses > .row:first > .form-column:last').offset().top
                    }, 500);

                    that.$modal.modal('hide');
                }

                that._cleanup();
            });
    };

    AddressBook.prototype._cleanup = function(dontClear) {
        if(dontClear === undefined || !dontClear) {
            this.$form.find('input:text, input[type="tel"]').val('');
        }
        this.validated = null;

        delete this.validated;
        delete this.$modal;
    };

    AddressBook.prototype.destroy = function() {
        // cleanup
        this._cleanup();

        // form
        this.$form.off('submit');
        delete this.$form;

        // element
        this.$element.off('click');
        this.$element.removeData(pluginName);
        this.$element = null;
    };

    /**
     * jQuery plugin wrapper
     */
    $.fn.addressBook = function(options) {
        return this.each(function(){
            var plugin = $.data(this, pluginName);

            if(!plugin) {
                $.data(this, pluginName, new AddressBook(this, options));
            }
        });
    };

})(jQuery);
